import React, { Fragment } from 'react';
import { Stack } from '@atlaskit/primitives';
import { ErrorBoundary } from '../../../common/ui/error-boundary';
var ErrorComponent = function ErrorComponent() {
  // when there's an error, render nothing but report the issue
  return /*#__PURE__*/React.createElement(Fragment, null, null);
};
export var ModalHero = function ModalHero(_ref) {
  var hero = _ref.hero;
  if (!hero) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, {
    testId: "link-create-modal-hero"
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    errorComponent: /*#__PURE__*/React.createElement(ErrorComponent, null)
  }, hero));
};